var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("第二层")]),_c('p',[_vm._v("----获取爷爷的数据-------------")]),_c('p',[_vm._v("info:"+_vm._s(_vm.info))]),_c('p',[_vm._v("msg:"+_vm._s(_vm.msg))]),_c('h4',[_vm._v("第二层的数据通过event-bus传递给层3")]),_c('button',{on:{"click":_vm.send}},[_vm._v("点击发送数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }